module.exports = __webpack_public_path__ + "static/img/Hotel-Brighton.2c1e5e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Hotel-Brighton.jpg
// module id = C2H7
// module chunks = 0